import { useState, useCallback } from 'react';
import { apiClient } from '../index';

interface LoginData {
  username: string;
  password: string;
}

export const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const login = useCallback(async (credentials: LoginData) => {
    setLoading(true);
    setError(null);
    try {
      const result = await apiClient.post('/api/auth/login', credentials);
      return result;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      return await apiClient.get('/api/auth/me');
    } catch (err) {
      throw err;
    }
  }, []);

  return {
    loading,
    error,
    login,
    checkAuth,
  };
};